export type KycSelectOption = {
    value: string;
    label: string;
};


export const kycIdOptions: KycSelectOption[] = [
    {
        value: "aadhaar-card",
        label: "Aadhaar Card",
    },
    {
        value: "pan-card",
        label: "PAN Card",
    },
    {
        value: "passport",
        label: "Passport",
    },
    {
        value: "driving-license",
        label: "Driving License",
    },
    {
        value: "voter-id",
        label: "Voter ID",
    },
    {
        value: "ssn",
        label: "SSN",
    },
];

export const countryOptions: KycSelectOption[] = [
    {
        value: "india",
        label: "India",
    },
    {
        value: "united-states",
        label: "United States",
    },
    {
        value: "united-arab-emirates",
        label: "United Arab Emirates",
    },
    {
        value: "united-kingdom",
        label: "United Kingdom",
    },
    {
        value: "canada",
        label: "Canada",
    },
    {
        value: "australia",
        label: "Australia",
    },
    {
        value: "germany",
        label: "Germany",
    },
    {
        value: "singapore",
        label: "Singapore",
    },
];

export const INDIAN_BANKS = [
    "Allahabad Bank",
    "Andhra Bank",
    "Axis Bank",
    "Bandhan Bank",
    "Bank of Baroda",
    "Bank of India",
    "Bank of Maharashtra",
    "Canara Bank",
    "Catholic Syrian Bank",
    "Central Bank of India",
    "City Union Bank",
    "DCB Bank",
    "Dhanlaxmi Bank",
    "Federal Bank",
    "HDFC Bank",
    "ICICI Bank",
    "IDBI Bank",
    "IDFC First Bank",
    "Indian Bank",
    "Indian Overseas Bank",
    "IndusInd Bank",
    "Jammu & Kashmir Bank",
    "Karnataka Bank",
    "Karur Vysya Bank",
    "Kotak Mahindra Bank",
    "Nainital Bank",
    "Oriental Bank of Commerce",
    "Punjab & Sind Bank",
    "Punjab National Bank",
    "RBL Bank",
    "South Indian Bank",
    "State Bank of India",
    "Tamilnad Mercantile Bank",
    "UCO Bank",
    "Union Bank of India",
    "United Bank of India",
    "Yes Bank",
];

export const bankOptionsByCountry: Record<string, KycSelectOption[]> = {
    india: INDIAN_BANKS.map((bank) => ({
        value: bank,
        label: bank,
    })),

    "united-states": [
        {
            value: "Bank of America",
            label: "Bank of America",
        },
        {
            value: "Chase",
            label: "Chase",
        },
        {
            value: "Wells Fargo",
            label: "Wells Fargo",
        },
        {
            value: "Citigroup",
            label: "Citigroup",
        },
    ],

    "united-arab-emirates": [
        {
            value: "Emirates NBD",
            label: "Emirates NBD",
        },
        {
            value: "Abu Dhabi Commercial Bank",
            label: "Abu Dhabi Commercial Bank",
        },
        {
            value: "First Abu Dhabi Bank",
            label: "First Abu Dhabi Bank",
        },
        {
            value: "Dubai Islamic Bank",
            label: "Dubai Islamic Bank",
        },
    ],

    "united-kingdom": [
        {
            value: "HSBC",
            label: "HSBC",
        },
        {
            value: "Barclays",
            label: "Barclays",
        },
        {
            value: "Lloyds Bank",
            label: "Lloyds Bank",
        },
        {
            value: "NatWest",
            label: "NatWest",
        },
    ],

    canada: [
        {
            value: "Royal Bank of Canada",
            label: "Royal Bank of Canada",
        },
        {
            value: "TD Bank",
            label: "TD Bank",
        },
        {
            value: "Scotiabank",
            label: "Scotiabank",
        },
    ],

    australia: [
        {
            value: "Commonwealth Bank",
            label: "Commonwealth Bank",
        },
        {
            value: "Westpac",
            label: "Westpac",
        },
        {
            value: "ANZ",
            label: "ANZ",
        },
    ],

    germany: [
        {
            value: "Deutsche Bank",
            label: "Deutsche Bank",
        },
        {
            value: "Commerzbank",
            label: "Commerzbank",
        },
    ],

    singapore: [
        {
            value: "DBS Bank",
            label: "DBS Bank",
        },
        {
            value: "OCBC Bank",
            label: "OCBC Bank",
        },
        {
            value: "UOB",
            label: "UOB",
        },
    ],
};

export const accountTypeOptions: KycSelectOption[] = [
    {
        value: "Savings",
        label: "Savings Account",
    },
    {
        value: "Current",
        label: "Current Account",
    },
    {
        value: "Salary",
        label: "Salary Account",
    },
];

export const getIdNumberPlaceholder = (idType: string) => {
    switch (idType) {
        case "aadhaar-card":
        case "Aadhar Card":
            return "Enter 12 digit Aadhaar number";

        case "pan-card":
        case "Pan Card":
            return "e.g. ABCDE1234F";

        case "passport":
        case "Passport":
        case "Passport (India)":
        case "Passport (Global)":
            return "e.g. A1234561 (8 chars)";

        case "driving-license":
        case "Driving License":
            return "e.g. HR-0619850034761";

        case "voter-id":
        case "Voter Id":
            return "Enter Voter ID number";

        case "ssn":
            return "Enter 9-digit SSN";

        default:
            return "Select ID type first";
    }
};

// Map between UI slug and Backend documentType string
export const toCanonicalIdType = (slugOrName: string): string => {
    switch (slugOrName) {
        case "aadhaar-card":
            return "Aadhar Card";
        case "pan-card":
            return "Pan Card";
        case "passport":
            return "Passport";
        case "driving-license":
            return "Driving License";
        case "voter-id":
            return "Voter Id";
        case "ssn":
            return "ssn";
        default:
            return slugOrName;
    }
};

export const fromCanonicalIdType = (nameOrSlug: string): string => {
    const lower = (nameOrSlug || "").trim().toLowerCase();
    if (lower.includes("aadhar") || lower.includes("aadhaar")) return "aadhaar-card";
    if (lower.includes("pan")) return "pan-card";
    if (lower.includes("passport")) return "passport";
    if (lower.includes("driving") || lower.includes("licence") || lower.includes("license")) return "driving-license";
    if (lower.includes("voter")) return "voter-id";
    if (lower === "ssn") return "ssn";
    return nameOrSlug;
};

// The Java global-KYC endpoint only accepts these documentType values (lowercase).
export const GLOBAL_ID_OPTIONS: KycSelectOption[] = [
    { value: "passport", label: "Passport" },
    { value: "driving-license", label: "Driving Licence" },
    { value: "ssn", label: "SSN" },
];

export const toGlobalDocType = (slugOrName: string): string => {
    const slug = fromCanonicalIdType(slugOrName);
    switch (slug) {
        case "passport":
            return "passport";
        case "driving-license":
            return "driving licence";
        case "ssn":
            return "ssn";
        default:
            return slug;
    }
};

